import React, { useState, useEffect, useRef } from 'react';
import 'rsuite/dist/rsuite.min.css';
import { calendarClock } from 'whealth-core-web/assets/images';
import './QueueView.scss';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';
import useApiManager from 'networking/ApiManager';
import { timeFormat, dateFormatStringSingleDate } from '../whealth-core-web/components/Helper';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal } from 'rsuite';
import { ToastContainer, toast } from 'react-toastify';
import { CommonAlert, Pagination, Select2DropDown, Loader, CoreButton, FilterChips, CoreInputBox } from 'whealth-core-web/components';
import { PDFViewer } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';

import OPDReportPDF from 'whealth-core-web/components/PrescriptionPdf/Content';
import { NotebookPen } from 'lucide-react';

const IpdView = () => {
  const ApiClient = useApiManager();
  const navigate = useNavigate();
  let userData = useGetLoginUserDataQuery()?.data?.data || {};
  const [modeData] = useState([
    { key: 'in-person', value: 'In-Person' },
    { key: 'virtual', value: 'Virtual' },
  ]);
  const value = useRef('');
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [countData, setCountData] = useState(0);
  const [startCount, setStartCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [userLocation,setUserLocation] = useState([])
  const [formData,setFormData] = useState({patient_name:"",age:"",gender:"",source:"",mr_no:"",mobile_no:"",panel:"",location:""})
  const [gender ,setGender] = useState([{"value":"Male","label":"Male"},{"value":"Female","label":"Female"},{"value":"Other","label":"Other"}])
  const [sourceData ,setSourceData] = useState([{"value":"IPD","label":"IPD"},{"value":"OPD","label":"OPD"},{"value":"Walkin","label":"Walkin"}])
  const [errMsg , setErrMsg] = useState('')
  const [backErrMsg , setBackErrMsg] = useState({})
  const [showPreview, setShowPreview] = useState(false);

  const sampleData = {
    "full_name": "New Patient Prescription",
    "gender": "male",
    "patient_id": "RHPL/AS/20360",
    "adjusted_time": "2025-11-13 19:30:37",
    "cm_name": "Nupur Lakhanpal",
    "cm_contact": "9667205666",
    "cm_address": "Nivaan clinic at Sama Hospital, 8, Siri Fort Rd, New Delhi, Delhi 110049",
    "age": "20",
    "height": null,
    "weight": null,
    "spo2": null,
    "blood_pressure": null,
    "glucose": null,
    "user_full_name": "New Patient Prescription",
    "doctor_name": "Dr Rohit Gulati",
    "doctor_degree": "DA, DNB",
    "doctor_specialization": "Senior pain consultant",
    "license_number": "30617",
    "prescription_date": "2025-11-14 10:58:04",
    "current_bmi": null,
    "business_phone_number": "9070057005",
    "business_email": "care@nivaancare.com",
    "business_name": "Nivaan",
    "business_address": "West Delhi | South Delhi | Gurgaon",
    "logo": "https://nivaancare-asset.s3.ap-south-1.amazonaws.com/logo.svg",
    "doctors_signature": null,
    "website_url": null,
    "vital_data": {
        "bp": "43",
        "bmi": 0,
        "pulse": "5345",
        "height": "",
        "weight": "",
        "respiration": "534",
        "temperature": "34"
    },
    "diagnosis_data": [
        {
            "remark": "gdfghfd",
            "diagnosis": "Achilles Tendinopathy"
        },
        {
            "remark": "gdfg",
            "diagnosis": "Baker's cyst"
        }
    ],
    "def_diagnosis_data": [
        {
            "remark": "gdfg",
            "diagnosis": "Ankylosing Spondylitis"
        },
        {
            "remark": "dfggdg",
            "diagnosis": "Back Musculoskeletal injury (strain/sprain)"
        }
    ],
    "pms_data": {
        "is_final": true,
        "vas_score": "10",
        "internal_note": "gyjghfds",
        "drug_allergies": [
            {
                "data": "Lignocaine",
                "remark": "gdgdfg"
            }
        ],
        "additional_note": "vefd",
        "final_diagnosis": 0,
        "health_condition": [
            {
                "remark": "gfd",
                "healthCondition": "Anxiety, mental health issues"
            },
            {
                "remark": "dfgb",
                "healthCondition": "Diabetes"
            }
        ],
        "next_checkin_date": "2025-11-13",
        "mdt_consults_advised": [
            "Nutrition"
        ],
        "principal_complaints": "<p>gdgh</p><p>drh</p><p>tfh</p><p>fdh</p><p>df</p><p>h</p>",
        "pain_treatment_history": "<p>hdfh</p><p>dh</p><p>dfh</p><p>dfh</p><p>df</p><p>hfd</p><p>h</p>",
        "previous_investigation_report": "<p>gfdg</p><p>gdfg</p><p>gdf</p><p>gd</p><p>f</p>"
    },
    "medication_data": [
        {
            "remark": "gdf",
            "current_medication": "Other"
        },
        {
            "remark": "gdfg",
            "current_medication": "Anti-coagulants"
        }
    ],
    "investigation_data": [
        {
            "test": "Prothrombin Time/INR, APTT, Viral markers - HIV, HbsAg, HCV, Blood Sugar Random",
            "remark": "gdf"
        },
        {
            "test": "CBC, Vit D, Vit B-12, Blood sugar - Fasting, PP, HbA1C, Thyroid Function Test, Kidney Function Test",
            "remark": "gdfg"
        }
    ],
    "treatment_procedure_data": [
        {
            "remark": "gdfg",
            "treatment": "Joint Injection Needling Surgery"
        },
        {
            "remark": "gdfgd",
            "treatment": "Ankle PRP Injection"
        }
    ],
    "treatment_other_data": [
        {
            "remark": "ewr4e5r",
            "treatment": "Custom sole"
        }
    ],
    "imaging_data": [
        {
            "image": "MRI - Sacro Iliac Joint",
            "remark": "gdfgf"
        }
    ],
    "red_alert": [
        {
            "remark": "gdfg",
            "redAlert": "Acute Trauma"
        },
        {
            "remark": "gdf",
            "redAlert": "Age of onset very young"
        }
    ],
    "treatment_medication": [
        {
            "meal": "After meal",
            "brand": "",
            "remark": "g",
            "regimen": "0-1-1",
            "duration": "ger",
            "medication": "Serratiopeptidase",
            "medication_id": 2150,
            "other_regimen": ""
        },
        {
            "meal": "Empty stomach",
            "brand": "",
            "remark": "gsd",
            "regimen": "0-1-1",
            "duration": "rdeg",
            "medication": "Gastopen",
            "medication_id": 2149,
            "other_regimen": ""
        }
    ],
    "next_checkin_date": "2025-11-13 00:00:00"
};

  const [isEditPatient, setIsEditPatient] = useState(false);
  const [permissions, setPermissions] = useState({});
 

  useEffect(() => {
    if (userData?.id) {
      getIpdUsers();
    }
  }, [userData, currentPage]);

  useEffect(() => {
    if (userData?.id && (searchStr.length > 1 || searchStr.length == 0)) {
      getIpdUsers();
    }
  }, [searchStr]);

  const getIpdUsers = () => {
    const today = new Date();
    // Convert to IST by adding 5 hours and 30 minutes
    const istDate = new Date(today.getTime());
    const formattedDate = dateFormatStringSingleDate(istDate);

    let paramsApp = `?searchStr=${searchStr}&user_id=${userData?.id}&page=${currentPage}`;
    ApiClient.getIpdUsers(paramsApp)
      .then((res) => {
        console.log('getipduser data: ', res?.data?.results);
        setData(res?.data?.results);
        setTotalPages(res?.data?.total_pages);
        setCountData(res?.data?.count);
        setPermissions(res?.data?.permissions);
        let startPage = res?.data?.page_size * currentPage - res?.data?.page_size;
        setStartCount(startPage);
        setUserLocation(res?.data?.location_list);
      })
      .catch((err) => {
        console.log('getipduser error: ', err);
      });
  };

  const handleChange = (name, data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: data,
    }));
  };

  const handleCancelClick = () => {
    setOpen(false);
    setTimeout(() => {
      setFormData({ patient_name: '', age: '', gender: '', source: '', mr_no: '', mobile_no: '', panel: '', location: '' });
      setIsEditPatient(false);
    }, 200);
  };
  const handleOpenPDF = async () => {
    const blob = await pdf(<OPDReportPDF data={sampleData} />).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };
  const renderHeader = () => {
    return (
      <>
        <div className='col-md-4'>
          <CoreInputBox
            placeholder='Search a patient by name, Clinic Patient ID, Nivaan Patient ID or Mobile No.'
            setValue={(val) => {
              setCurrentPage(1);
              value.current = val;
              setSearchStr(val);
            }}
            value={searchStr}
            inputStyle={{ height: '24px', fontSize: '9px' }}
          />
        </div>

        <div className='col-md-1' style={{ float: 'right' }}>
          {!userData?.read_only && (
          <Button
            className='m-0 reusableBtn reusableBtnActive'
            onClick={() => {
              setOpen(true);
            }}
            style={{ fontSize: '9px' }}
          >
            {'Add patient'}
          </Button>
          )}
           {/* <button onClick={handleOpenPDF}>Open PDF in New Tab</button> */}
      
        </div>
      </>
    );
  };

  const goToPatientProfile = (patientId) => {
    navigate(`/patient/${patientId}/dashboard`);
  };

  const showDetails = () => (
    <>
      <div className='teamHeader stickyHeader'>
        <div className='headerFilesRow'>{renderHeader()}</div>
        <div className='hrLine' />
        <div className='row'>
          <div className='col-md-12'>
            <table className='table table-bordered table-hover'>
              <thead>
                <tr className='table-theme'>
                  <th className='table-theme'>Sno</th>
                  <th className='table-theme'>Name</th>
                  <th className='table-theme'>Mobile No.</th>
                  <th className='table-theme'>Clinic Patient ID</th>
                  <th className='table-theme'>Nivaan Patient ID</th>
                  <th className='table-theme'>Clinic</th>
                  <th className='table-theme'>Age</th>
                  <th className='table-theme'>Panel</th>
                  <th className='table-theme'>Created By</th>
                  {permissions?.edit && !userData?.read_only && <th className='table-theme'>Action</th>}
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className='align-content-center'>{startCount + index + 1}</td>
                    <td className='align-content-center'>
                      <Link className='userName' style={{ color: '#133696' }} to={`/ipdUser/${item.id}`}>
                        {item.patient_name}
                      </Link>
                    </td>
                    <td className='align-content-center'>{item.mobile_no}</td>
                    <td className='align-content-center'>{item.mr_no}</td>
                    <td className='align-content-center'>{item?.patient_code}</td>
                    <td className='align-content-center'>{item?.location?.name}</td>
                    <td className='align-content-center'>{item.age}</td>
                    <td className='align-content-center'>{item.panel}</td>
                    <td className='align-content-center'>{item?.admin?.full_name}</td>
                    {permissions?.edit && !userData?.read_only && (
                      <td className='align-content-center d-flex justify-content-center gap-1'>
                        <a
                          onClick={() => {
                            setIsEditPatient(true);
                            setFormData({ ...item });
                            setOpen(true);
                          }}
                          className='text-decoration-none'
                          style={{ color: '#133696', cursor: 'pointer' }}
                        >
                          <NotebookPen style={{ width: '16px' }} />
                        </a>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='usersList wrapperContent'>
        <div className='d-flex justify-content-end mb-4'>
          <Pagination data={data} length={countData} totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} page='patient' />
        </div>
      </div>

      <Modal backdrop='static' keyboard={false} open={open} onClose={handleCancelClick}>
        <Modal.Header>
          <Modal.Title>{isEditPatient ? 'Update Patient' : 'Add Patient'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-6'>
              <CoreInputBox
                type={`text`}
                retuired={true}
                label={'Patient Name'}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('patient_name', data)}
                value={formData?.patient_name}
              />
            </div>
            <div className='col-md-6'>
              <Select2DropDown
                value={formData?.source}
                data={sourceData}
                label={`Source`}
                placeholder={`Source`}
                valueKey='value'
                labelKey='label'
                retuired={true}
                onSelect={(selectedValue, dataObj) => {
                  handleChange('source', selectedValue);
                }}
              />
            </div>
            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={formData?.source == 'IPD' ? true : false}
                label={'Clinic Patient ID'}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('mr_no', data)}
                value={formData?.mr_no}
              />
            </div>
            <div className='col-md-6 mt-2'>
              <Select2DropDown
                value={formData?.gender}
                data={gender}
                label={`Gender`}
                placeholder={`Gender`}
                valueKey='value'
                labelKey='label'
                retuired={true}
                onSelect={(selectedValue, dataObj) => {
                  handleChange('gender', selectedValue);
                }}
              />
            </div>
            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={true}
                label={'Age'}
                maxLength={3}
                validateMax={150}
                validateNumbers={true}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('age', data)}
                value={formData?.age}
              />
            </div>
            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={formData?.source == 'IPD' ? false : true}
                label={'Mobile Number'}
                maxLength={10}
                validateNumbers={true}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('mobile_no', data)}
                value={formData?.mobile_no}
              />
            </div>
            <div className='col-md-6 mt-2'>
              <Select2DropDown
                disabled={isEditPatient}
                value={isEditPatient ? formData.location?.id : formData.location}
                data={userLocation}
                label={`Clinic`}
                placeholder={`Clinic`}
                valueKey='value'
                labelKey='label'
                retuired={true}
                onSelect={(selectedValue, dataObj) => {
                  console.log(selectedValue);
                  handleChange('location', selectedValue);
                }}
              />
            </div>
            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={false}
                label={'Panel'}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('panel', data)}
                value={formData?.panel}
              />
            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-md-12'>
              <CoreButton
                onClick={() => {
                  if (['Walkin', 'OPD'].includes(formData?.source) && formData?.mobile_no.length < 10) {
                    setErrMsg('Please enter valid mobile no');
                    return false;
                  }
                  if (['IPD'].includes(formData?.source) && formData?.mobile_no.length < 10 && formData?.mobile_no.length > 0) {
                    setErrMsg('Please enter valid mobile no');
                    return false;
                  }

                  setErrMsg('');
                  setBackErrMsg({});
                  if (
                    formData?.patient_name == '' ||
                    formData?.location == null ||
                    formData?.location == '' ||
                    formData?.gender == '' ||
                    formData?.age == '' ||
                    (formData?.source == 'IPD' && formData?.mr_no == '') ||
                    (['Walkin', 'OPD'].includes(formData?.source) && formData?.mobile_no == '')
                  ) {
                    setErrMsg('Please fill all mandatory fields');
                  } else if (isEditPatient) {
                    ApiClient.updateIpdUsers(formData)
                      .then((res) => {
                        if (res?.data?.success) {
                          toast.success('Patient Details Updated!');
                          handleCancelClick();
                          getIpdUsers();
                        } else {
                          toast.error('Something went wrong');
                        }
                      })
                      .catch((err) => {
                        handleCancelClick();
                        let response = err?.response?.data;
                        let message = response?.detail || response?.message;
                        setIsEditPatient(false);
                        toast.error(message);
                      });
                    setFormData((prevData) => ({ patient_name: '', age: '', gender: '', source: '', mr_no: '', mobile_no: '', panel: '', location: '' }));
                    setIsEditPatient(false);
                  } else {
                    ApiClient.saveIpdUsers(formData)
                      .then((res) => {
                        if (res?.data?.id) {
                          setOpen(false);
                          toast.success('Saved!');
                          setFormData((prevData) => ({ patient_name: '', age: '', gender: '', source: '', mr_no: '', mobile_no: '', panel: '', location: '' }));
                          getIpdUsers();
                        } else {
                          toast.error('Something went wrong');
                        }
                      })
                      .catch((err) => {
                        setBackErrMsg(err?.response?.data);
                      });
                  }
                }}
                customClass='btn btn-secondary btn-lg'
                title={isEditPatient ? 'Update Details' : 'Save Details'}
              />
              <p style={{ color: 'red', textAlign: 'center', fontSize: '12px', display: errMsg || backErrMsg ? 'block' : 'none' }}>
                {errMsg && `*** ${errMsg} ***`}
                <br />
                {backErrMsg?.mr_no}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );

  return (
    <div className='wrapper'>
      {showDetails()}
      <ToastContainer />
    </div>
  );
};

export default IpdView;
